import XMark from "./XMark.png";

const xMark = () => {
  return <img src={XMark} alt="checked" width="20px" height="20px" />;
};

export default xMark;
